(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(44915);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 14380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ FormattedDate; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _lib_date__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57923);
/* harmony import */ var _lib_wovn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15598);




// Returns formatted date of iso string
var FormattedDate = function(props) {
    if (!props.children) {
        return null;
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("span", {
        className: props.className,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("span", {
            className: _lib_wovn__WEBPACK_IMPORTED_MODULE_2__/* .IGNORED_BY_WOVN_CLASS_NAME */ .Y,
            suppressHydrationWarning: true,
            children: (0,_lib_date__WEBPACK_IMPORTED_MODULE_3__/* .formatDate */ .p6)(props.children, "yyyy/MM/dd")
        })
    });
};


/***/ }),

/***/ 88402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ LineClamp; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);




var LineClamp = function(param) {
    var lineNumber = param.lineNumber, _showAll = param.showAll, showAll = _showAll === void 0 ? false : _showAll, _justify = param.justify, justify = _justify === void 0 ? false : _justify, lineClampRef = param.lineClampRef, className = param.className, children = param.children, title = param.title;
    if (typeof lineNumber === "number") {
        lineNumber = {
            desktop: lineNumber,
            mobile: lineNumber
        };
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(justify ? "text-align: justify;" : "", " ", showAll || "\n          overflow: hidden;\n          display: -webkit-box;\n          -webkit-box-orient: vertical;\n          -webkit-line-clamp: ".concat(lineNumber.desktop, ";\n          ").concat(plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.untilMedium, " {\n            -webkit-line-clamp: ").concat(lineNumber.mobile, ";\n            line-height: 1.75;\n          }\n        ")),
        className: className,
        ref: lineClampRef,
        title: title,
        children: children
    });
};


/***/ }),

/***/ 89277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ LineClampText; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);




var LineClampText = function(param) {
    var lineNumber = param.lineNumber, _showAll = param.showAll, showAll = _showAll === void 0 ? false : _showAll, _height = param.height, height = _height === void 0 ? 1.4 : _height, _size = param.size, size = _size === void 0 ? "14px" : _size, _stripLineBreaks = param.stripLineBreaks, stripLineBreaks = _stripLineBreaks === void 0 ? false : _stripLineBreaks, _justify = param.justify, justify = _justify === void 0 ? false : _justify, lineClampRef = param.lineClampRef, className = param.className, children = param.children, dataTestId = param.dataTestId;
    if (typeof lineNumber === "number") {
        lineNumber = {
            desktop: lineNumber,
            mobile: lineNumber
        };
    }
    var text = stripLineBreaks ? children === null || children === void 0 ? void 0 : children.replace(/(\r\n|\n|\r)/gm, "") : children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("span", {
        title: text !== null && text !== void 0 ? text : "",
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("line-height:", height, ";font-size:", size, ";", justify ? "text-align: justify;" : "", " ", showAll || "\n          max-height: calc(".concat(size, " * ").concat(height, " * ").concat(lineNumber.desktop, ");\n          display: -webkit-box;\n          -webkit-box-orient: vertical;\n          overflow: hidden;\n          -webkit-line-clamp: ").concat(lineNumber.desktop, ";\n          ").concat(plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.untilMedium, " {\n            max-height: calc(").concat(size, " * ").concat(height, " * ").concat(lineNumber.mobile, ");\n            -webkit-line-clamp: ").concat(lineNumber.mobile, ";\n          }\n        ")),
        className: className,
        ref: lineClampRef,
        "data-test-id": dataTestId,
        children: text
    });
};


/***/ }),

/***/ 15071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ TagButton; },
/* harmony export */   "U": function() { return /* binding */ TagButtonGroup; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4807);
/* harmony import */ var _lib_url__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48261);






var TagButton = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("li", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("display:inline-block;margin:0 4px 4px 0;"),
        "data-test-id": "tag",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: _lib_url__WEBPACK_IMPORTED_MODULE_3__/* .TAG_HREF */ .cS,
            as: "slug" in props.tag ? (0,_lib_url__WEBPACK_IMPORTED_MODULE_3__/* .newTagPath */ .w6)(props.tag) : props.tag.path,
            passHref: true,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("a", {
                "data-test-id": "tag-link",
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray40 */ .O9.gray40, ";border-radius:3px;padding:2px 6px;font-size:12px;line-height:1.5;color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray90 */ .O9.gray90, ";text-align:center;display:block;white-space:nowrap;transition:0.3s;&:hover{color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.white00 */ .O9.white00, ";background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray70 */ .O9.gray70, ";}"),
                className: "tag-button ".concat(props.className ? props.className : ""),
                children: "#".concat(props.tag.name)
            })
        })
    });
};
var TagButtonGroup = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("ul", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("margin:0 0 -4px;padding:0;"),
        className: props.className,
        "data-test-id": props.dataTestId,
        children: props.children
    });
};


/***/ }),

/***/ 90308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ ForEnterprise; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _contexts_AuthContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18584);
/* harmony import */ var _lib_user__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73650);




var ForEnterprise = function(props) {
    var user = (0,_contexts_AuthContext__WEBPACK_IMPORTED_MODULE_1__/* .useUser */ .a)();
    if ((0,_lib_user__WEBPACK_IMPORTED_MODULE_2__/* .isEnterpriseWithTrial */ .xQ)(user)) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .Fragment */ .HY, {
            children: props.children
        });
    } else {
        return null;
    }
};


/***/ }),

/***/ 12912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ CompanyHead; },
/* harmony export */   "HG": function() { return /* binding */ SearchCompaniesHead; },
/* harmony export */   "SG": function() { return /* binding */ OverseasCompanyHead; },
/* harmony export */   "UJ": function() { return /* binding */ DefaultHead; },
/* harmony export */   "WD": function() { return /* binding */ ArticlesHead; },
/* harmony export */   "cm": function() { return /* binding */ NewTagHead; },
/* harmony export */   "dh": function() { return /* binding */ SearchHead; },
/* harmony export */   "hw": function() { return /* binding */ InvestorHead; },
/* harmony export */   "iG": function() { return /* binding */ NoticeHead; },
/* harmony export */   "ls": function() { return /* binding */ ArticleHead; },
/* harmony export */   "sD": function() { return /* binding */ RoundsHead; },
/* harmony export */   "tk": function() { return /* binding */ SearchInvestorsHead; },
/* harmony export */   "vB": function() { return /* binding */ FeaturedHead; },
/* harmony export */   "yU": function() { return /* binding */ StatusSettingHead; }
/* harmony export */ });
/* unused harmony exports SeminarHead, CircleHead */
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _lib_url__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48261);




var DefaultHead = function(param) {
    var _title = param.title, title = _title === void 0 ? "スピーダ スタートアップ情報リサーチ" : _title, _description = param.description, description = _description === void 0 ? "スタートアップ投資や協業を成功させるために、事業内容・資金調達状況・提携先・関連ニュース・投資家情報・分析レポートなどの検索から取得管理までシームレスに行える情報プラットフォームです。" : _description, _image = param.image, image = _image === void 0 ? "".concat(_lib_url__WEBPACK_IMPORTED_MODULE_2__/* .host */ .ho, "/static/images/ogp.png") : _image, _url = param.url, url = _url === void 0 ? "https://initial.inc/" : _url, _twitterCard = param.twitterCard, twitterCard = _twitterCard === void 0 ? "summary_large_image" : _twitterCard, children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                name: "keywords",
                content: "スピーダ,スタートアップ,NewsPicksスタートアップ,startup,ベンチャー"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:url",
                content: url
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:image",
                content: image
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:site_name",
                content: "スピーダ スタートアップ情報リサーチ"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                name: "twitter:card",
                content: twitterCard
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                name: "twitter:site",
                content: "@".concat(_lib_url__WEBPACK_IMPORTED_MODULE_2__/* .twitterUserName */ .IR)
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                name: "twitter:creator",
                content: "@".concat(_lib_url__WEBPACK_IMPORTED_MODULE_2__/* .twitterUserName */ .IR)
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                name: "twitter:url",
                content: url
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                name: "twitter:image",
                content: image
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("link", {
                rel: "canonical",
                href: url
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                name: "viewport",
                content: "width=device-width,height=device-height"
            }, "viewport"),
            children
        ]
    });
};
var ArticlesHead = function() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(DefaultHead, {
        title: "オリジナル記事｜スピーダ スタートアップ情報リサーチ",
        description: "スピーダ スタートアップ情報リサーチのオリジナル記事はこちら",
        url: _lib_url__WEBPACK_IMPORTED_MODULE_2__/* .articlesUrl */ .LT
    });
};
var ArticleHead = function(param) {
    var article = param.article;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(DefaultHead, {
        title: "".concat(article.title, "｜スピーダ スタートアップ情報リサーチ"),
        description: article.introduction,
        url: (0,_lib_url__WEBPACK_IMPORTED_MODULE_2__/* .articleUrl */ .MG)(article),
        image: article.headerImage.url,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("script", {
            dangerouslySetInnerHTML: {
                __html: JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "Article",
                    headline: article.title,
                    image: [
                        article.headerImage.url
                    ],
                    datePublished: article.publishedAt
                })
            },
            type: "application/ld+json"
        })
    });
};
var SeminarHead = function(param) {
    var seminar = param.seminar;
    return /*#__PURE__*/ _jsx(DefaultHead, {
        title: "".concat(seminar.title, "｜スピーダ スタートアップ情報リサーチ"),
        description: seminar.introduction,
        url: seminarUrl(seminar.slug),
        image: seminar.headerImage.url
    });
};
var NewTagHead = function(param) {
    var tag = param.tag;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(DefaultHead, {
        title: "".concat(tag.name, "｜スピーダ スタートアップ情報リサーチ"),
        url: (0,_lib_url__WEBPACK_IMPORTED_MODULE_2__/* .newTagUrl */ .Cc)(tag),
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
            name: "viewport",
            content: "width=1200px"
        }, "viewport")
    });
};
var CompanyHead = function(param) {
    var company = param.company, children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(DefaultHead, {
        title: "".concat(company.name, "｜スピーダ スタートアップ情報リサーチ"),
        description: company.description,
        url: (0,_lib_url__WEBPACK_IMPORTED_MODULE_2__/* .companyUrl */ .c2)(company),
        image: company.imageUrl,
        twitterCard: company.imageUrl ? "summary" : undefined,
        children: children
    });
};
var OverseasCompanyHead = function(param) {
    var company = param.company, children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(DefaultHead, {
        title: "".concat(company.name, "｜スピーダ スタートアップ情報リサーチ"),
        description: company.description || "",
        children: children
    });
};
var InvestorHead = function(param) {
    var investor = param.investor;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(DefaultHead, {
        title: "".concat(investor.name, "｜スピーダ スタートアップ情報リサーチ"),
        description: investor.description,
        url: (0,_lib_url__WEBPACK_IMPORTED_MODULE_2__/* .investorUrl */ .J4)(investor.shortname),
        image: investor.imageUrl,
        twitterCard: investor.imageUrl ? "summary" : undefined
    });
};
var FeaturedHead = function(param) {
    var featured = param.featured;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(DefaultHead, {
        title: "".concat(featured.title, "｜スピーダ スタートアップ情報リサーチ"),
        description: featured.description,
        url: (0,_lib_url__WEBPACK_IMPORTED_MODULE_2__/* .featuredUrl */ .Qu)(featured.slug),
        image: featured.ogpImage.url
    });
};
var SearchHead = function() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(DefaultHead, {
        title: "検索｜スピーダ スタートアップ情報リサーチ",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
            name: "viewport",
            content: "width=1200px"
        }, "viewport")
    });
};
var RoundsHead = function() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(DefaultHead, {
        title: "資金調達検索｜スピーダ スタートアップ情報リサーチ",
        description: "スピーダ スタートアップ情報リサーチの資金調達検索はこちら"
    });
};
var StatusSettingHead = function() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(DefaultHead, {
        title: "ステータス設定｜スピーダ スタートアップ情報リサーチ",
        description: "スピーダ スタートアップ情報リサーチのステータス設定についてはこちら"
    });
};
var NoticeHead = function(param) {
    var notice = param.notice;
    var ref;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(DefaultHead, {
        title: "".concat(notice.title, "｜スピーダ スタートアップ情報リサーチ"),
        image: notice.headerImage.url,
        description: (ref = notice.body) === null || ref === void 0 ? void 0 : ref.slice(0, 100),
        url: notice.slug ? _lib_url__WEBPACK_IMPORTED_MODULE_2__/* .host */ .ho + (0,_lib_url__WEBPACK_IMPORTED_MODULE_2__/* .noticePath */ .$t)(notice.slug) : _lib_url__WEBPACK_IMPORTED_MODULE_2__/* .host */ .ho
    });
};
var SearchCompaniesHead = function() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(DefaultHead, {
        title: "スタートアップ｜スピーダ スタートアップ情報リサーチ",
        description: "スピーダ スタートアップ情報リサーチのスタートアップ企業検索はこちら",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
            name: "viewport",
            content: "width=1200px"
        }, "viewport")
    });
};
var SearchInvestorsHead = function() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(DefaultHead, {
        title: "投資家｜スピーダ スタートアップ情報リサーチ",
        description: "スピーダ スタートアップ情報リサーチの投資家検索はこちら"
    });
};
var CircleHead = function() {
    return /*#__PURE__*/ _jsx(DefaultHead, {
        title: "ユーザーコミュニティ「INITIAL Circle」｜INITIAL",
        description: "INITIALユーザーの知見と人脈をつなぎ、循環させるためのユーザーコミュニティ「INITIAL Circle」。INITIALを利用する、VC、CVC、事業会社、行政、金融、研究機関、スタートアップのみなさんが、所属する組織や地域、立場の垣根を超えて、自由に交流する場です。",
        url: enterpriseCircleUrl,
        image: "".concat(host, "/static/images/enterprise/index/ogp_enterprise.png")
    });
};


/***/ }),

/***/ 39347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ NPFeedPublisherAndPublishedDate; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _lib_date__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57923);





var NPFeedPublisherAndPublishedDate = function(param) {
    var publisher = param.publisher, publishedDate = param.publishedDate, _lineHeight = param.lineHeight, lineHeight = _lineHeight === void 0 ? 1.0 : _lineHeight, _fontSize = param.fontSize, fontSize = _fontSize === void 0 ? "14px" : _fontSize, className = param.className;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)("div", {
        className: className,
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("font-size:", fontSize, ";line-height:", lineHeight, ";color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.textLight */ .O9.textLight, ";display:flex;flex-flow:row nowrap;"),
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("span", {
                className: "np-feed-publisher",
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("display:inline-block;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;width:min-content;height:100%;max-width:580px;overflow:hidden;"),
                children: publisher
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("span", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("margin:0px 4px;"),
                children: "・"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("span", {
                className: "np-feed-publish-date",
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("word-break:keep-all;"),
                children: (0,_lib_date__WEBPACK_IMPORTED_MODULE_4__/* .formatDateByDistanceToNow */ .Wz)(publishedDate)
            })
        ]
    });
};


/***/ }),

/***/ 3278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ PickersIcons; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            position: relative;\n            display: inline-block;\n            box-sizing: content-box;\n            width: 24px;\n            height: 24px;\n            border-radius: 50%;\n            border: 2px solid white;\n            top: 0%;\n            left: ",
        ";\n            z-index: ",
        ";\n          "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var PickersIcons = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", {
        className: props.className,
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("height:", 24 + 2 * 2, "px;margin-right:-", 6 * (props.pickers.length - 1), "px;"),
        children: props.pickers.map(function(p, i) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("img", {
                alt: "picker icon",
                className: "np-feed-picker-icon",
                css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), -6 * i + "px", 18 - i),
                src: p.image ? p.image : "/static/images/top/np-picker-blank-avatar.png"
            }, i);
        })
    });
};


/***/ }),

/***/ 28547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ useTimeout; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useTimeout = function(timeout) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isTimeout = ref[0], setIsTimeout = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var timer = setTimeout(function() {
            setIsTimeout(true);
        }, timeout);
        return function() {
            return clearTimeout(timer);
        };
    }, []);
    return isTimeout;
};


/***/ }),

/***/ 25769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O6": function() { return /* binding */ getCategoryTagColor; }
/* harmony export */ });
/* unused harmony exports convertHexColorToRGB, categoryTagColor */
var convertHexColorToRGB = function(hex) {
    if (hex.slice(0, 1) == "#") hex = hex.slice(1);
    if (hex.length == 3) {
        hex = hex.slice(0, 1) + hex.slice(0, 1) + hex.slice(1, 2) + hex.slice(1, 2) + hex.slice(2, 3) + hex.slice(2, 3);
    }
    return [
        hex.slice(0, 2),
        hex.slice(2, 4),
        hex.slice(4, 6)
    ].map(function(str) {
        return parseInt(str, 16);
    });
};
var categoryTagColor = {
    yellow10: "#FFFAEB",
    yellow60: "#D19D00",
    blue10: "#F2F6FA",
    blue60: "#0863BF",
    cyan10: "#F0F6F8",
    cyan60: "#1B8298",
    navy10: "#F2F4FA",
    navy60: "#1F3A8C",
    green10: "#F2FAF3",
    green60: "#2F943C",
    forestGreen10: "#F7FCEB",
    forestGreen60: "#6F9905",
    red10: "#FFF2F2",
    red60: "#db351f",
    brown10: "#F7F3F0",
    brown60: "#704831",
    gray20: "#FAFAFA",
    gray90: "#666"
};
var getCategoryTagColor = function(category) {
    switch(category){
        case "資金調達":
            return {
                color: categoryTagColor.yellow60,
                backgroundColor: categoryTagColor.yellow10
            };
        case "資本提携":
            return {
                color: categoryTagColor.forestGreen60,
                backgroundColor: categoryTagColor.forestGreen10
            };
        case "資金参加":
            return {
                color: categoryTagColor.brown60,
                backgroundColor: categoryTagColor.brown10
            };
        case "事業提携":
            return {
                color: categoryTagColor.blue60,
                backgroundColor: categoryTagColor.blue10
            };
        case "子会社化":
            return {
                color: categoryTagColor.red60,
                backgroundColor: categoryTagColor.red10
            };
        case "株式譲渡":
            return {
                color: categoryTagColor.navy60,
                backgroundColor: categoryTagColor.navy10
            };
        case "事業譲渡":
            return {
                color: categoryTagColor.cyan60,
                backgroundColor: categoryTagColor.cyan10
            };
        case "ファンド組成":
            return {
                color: categoryTagColor.green60,
                backgroundColor: categoryTagColor.green10
            };
        default:
            return {
                color: categoryTagColor.gray90,
                backgroundColor: categoryTagColor.gray20
            };
    }
};


/***/ }),

/***/ 15598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ IGNORED_BY_WOVN_CLASS_NAME; }
/* harmony export */ });
var IGNORED_BY_WOVN_CLASS_NAME = "wovn-ignore";


/***/ }),

/***/ 44915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/plume-ui/dist/index.js
var dist = __webpack_require__(4807);
// EXTERNAL MODULE: ./components/common/Head.tsx
var Head = __webpack_require__(12912);
// EXTERNAL MODULE: ./components/common/Template.tsx
var Template = __webpack_require__(33431);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./components/atoms/LineClamp.tsx
var LineClamp = __webpack_require__(88402);
// EXTERNAL MODULE: ./components/atoms/LineClampText.tsx
var LineClampText = __webpack_require__(89277);
// EXTERNAL MODULE: ./components/atoms/TagButton.tsx
var TagButton = __webpack_require__(15071);
// EXTERNAL MODULE: ./components/common/ForEnterprise.tsx
var ForEnterprise = __webpack_require__(90308);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/atoms/IcomoonIcon.tsx
var IcomoonIcon = __webpack_require__(96747);
;// CONCATENATED MODULE: ./components/pages/top/ShowAllLink.tsx






var ShowAllLink = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: props.href,
        prefetch: false,
        passHref: true,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:14px;color:", dist/* colors.text */.O9.text, ";white-space:nowrap;&:hover{color:", dist/* colors.link */.O9.link, ";}"),
            className: "view-all ".concat(props.className),
            target: "_blank",
            children: [
                "すべて見る",
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:9px;font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";margin-left:5px;position:relative;top:-1px;"),
                    name: "arrow4-right"
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/pages/top/SubSection.tsx





var TopSectionCard = function(param) {
    var id = param.id, className = param.className, children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        id: id,
        className: className,
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.black10 */.O9.black10, ";box-shadow:0px 4px 16px rgba(0,0,0,0.04);border-radius:8px;overflow:hidden;", dist.mq.untilMedium, "{box-shadow:none;}"),
        children: children
    });
};
var TopSectionCardTitle = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        id: props.id,
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:18px;line-height:100%;padding:24px 24px 8px 0;background-color:", dist/* colors.white00 */.O9.white00, ";", dist.mq.untilMedium, "{background-color:transparent;padding:0 4px 8px;font-size:20px;}"),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("border-left:6px solid #0071e3;display:flex;align-items:center;justify-content:space-between;padding-left:16px;", dist.mq.untilMedium, "{border-left:none;padding-left:0;}"),
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("> *{vertical-align:middle;}"),
                    children: [
                        props.subTitle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.textLight */.O9.textLight, ";font-size:14px;line-height:125%;padding:2px 0;"),
                            children: props.subTitle
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            className: "section-title",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:20px;font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";line-height:1.5;white-space:nowrap;"),
                            children: props.title
                        })
                    ]
                }),
                props.showAllUrl && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ForEnterprise/* ForEnterprise */.L, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("> *{vertical-align:middle;}"),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShowAllLink, {
                            href: props.showAllUrl,
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-left:12px;")
                        })
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/pages/top/CompanyAccessRanking.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                    display: inline-block;\n                    &:not(:last-of-type) {\n                      margin-right: 4px;\n                    }\n                  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var CompanyAccessRanking = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TopSectionCard, {
        id: "access-ranking-section",
        className: "access-ranking",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TopSectionCardTitle, {
                title: "アクセスランキング",
                subTitle: "国内スタートアップ"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("> *:not(:last-child){position:relative;}> *:not(:last-child)::after{content:'';position:absolute;height:1px;bottom:0px;left:16px;width:calc(100% - 32px);background-color:", dist/* colors.gray50 */.O9.gray50, ";}", dist.mq.untilMedium, "{overflow:hidden;border-radius:8px;box-shadow:0px 0px 4px rgba(0,0,0,0.08);}"),
                children: props.companies.slice(0, 5).map(function(company, index) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyAccessRankingItem, {
                        company: company,
                        rank: index + 1
                    }, index);
                })
            })
        ]
    });
};
var rankingImg = function(rank) {
    return "/static/images/ranking/icon_ranking-".concat(rank, "@2x.png");
};
var CompanyAccessRankingItem = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background-color:", dist/* colors.white00 */.O9.white00, ";"),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
            href: props.company.path,
            passHref: true,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                className: "company-item",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:inline-block;color:", dist/* colors.black10 */.O9.black10, ";padding:16px 24px 24px;width:100%;&:hover{background-color:rgba(0,0,0,0.03);}", dist.mq.untilMedium, "{padding:16px;}"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;justify-content:space-between;margin-bottom:8px;"),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;flex:1;"),
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                                        alt: "company rank",
                                        src: rankingImg(props.rank),
                                        className: "company-rank",
                                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:20px;height:20px;margin-right:8px;")
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        className: "company-name",
                                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:100%;margin-right:16px;"),
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";font-size:14px;line-height:140%;text-decoration:underline solid transparent;transition:text-decoration 0.2s ease 0s;&:hover{text-decoration:underline solid Currentcolor;transition:text-decoration 0.2s ease 0s;}", dist.mq.untilMedium, "{font-size:15px;}"),
                                            children: props.company.name
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* CompanyLogo */.Dc, {
                                src: props.company.imageUrl || "/static/images/default/company.png",
                                name: props.company.name,
                                className: "company-logo",
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("&:hover{box-shadow:0px 0px 12px rgba(0,0,0,0.08);}")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.black30 */.O9.black30, ";overflow:hidden;"),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LineClampText/* LineClampText */.R, {
                                className: "company-description",
                                lineNumber: 4,
                                height: 1.5,
                                size: "14px",
                                children: props.company.description
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LineClamp/* LineClamp */.x, {
                                className: "company-tags",
                                lineNumber: 2,
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.textLight */.O9.textLight, ";line-height:1.75;margin-top:8px;"),
                                children: props.company.tags.map(function(tag, i) {
                                    return(// Safariのline-clampの挙動がおかしい対応でspanで囲っている
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                        css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject()),
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagButton/* TagButton */.D, {
                                            tag: tag
                                        })
                                    }, i));
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var src_class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs
var src_inherits = __webpack_require__(28668);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var src_create_super = __webpack_require__(91224);
;// CONCATENATED MODULE: ./components/hoc/ErrorBoundary.tsx






var ErrorBoundary = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,src_inherits/* default */.Z)(ErrorBoundary, _Component);
    var _super = (0,src_create_super/* default */.Z)(ErrorBoundary);
    function ErrorBoundary(props) {
        (0,src_class_call_check/* default */.Z)(this, ErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            hasError: false
        };
        return _this;
    }
    var _proto = ErrorBoundary.prototype;
    _proto.render = function render() {
        if (this.state.hasError) {
            return null;
        }
        return this.props.children;
    };
    ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(_) {
        return {
            hasError: true
        };
    };
    return ErrorBoundary;
}(react.Component);
var withErrorBoundary = function(Component) {
    return /*#__PURE__*/ function(_Component) {
        "use strict";
        _inherits(ErrorBoundaryComponent, _Component);
        var _super = _create_super(ErrorBoundaryComponent);
        function ErrorBoundaryComponent() {
            _class_call_check(this, ErrorBoundaryComponent);
            return _super.apply(this, arguments);
        }
        var _proto = ErrorBoundaryComponent.prototype;
        _proto.render = function render() {
            return /*#__PURE__*/ _jsx(ErrorBoundary, {
                children: /*#__PURE__*/ _jsx(Component, _object_spread({}, this.props))
            });
        };
        return ErrorBoundaryComponent;
    }(React.Component);
};

// EXTERNAL MODULE: ./lib/colors.ts
var colors = __webpack_require__(25769);
// EXTERNAL MODULE: ./components/atoms/FormattedDate.tsx
var FormattedDate = __webpack_require__(14380);
;// CONCATENATED MODULE: ./components/pages/top/DomesticFinanceNewsSection.tsx








var DomesticFinanceNewsSection = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ErrorBoundary, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TopSectionCard, {
            id: "finance-ma-section",
            className: "domestic-finance-news",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TopSectionCardTitle, {
                    title: "資金調達・提携ニュース",
                    subTitle: "国内スタートアップ",
                    showAllUrl: "/finance_news"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("> *:not(:last-child){position:relative;}> *:not(:last-child)::after{content:'';position:absolute;height:1px;bottom:0px;left:16px;width:calc(100% - 32px);background-color:", dist/* colors.gray50 */.O9.gray50, ";}", dist.mq.untilMedium, "{> *:not(:last-child)::after{display:none;}> *:not(:last-child){margin-bottom:8px;}}"),
                    children: props.financeNews.slice(0, 6).map(function(financeNews, index) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DomesticFinanceNewsItem, {
                            financeNews: financeNews
                        }, index);
                    })
                })
            ]
        })
    });
};
var DomesticFinanceNewsItem = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background-color:", dist/* colors.white00 */.O9.white00, ";color:", dist/* colors.black30 */.O9.black30, ";", dist.mq.untilMedium, "{border-radius:8px;box-shadow:0px 0px 4px rgba(0,0,0,0.08);}"),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: "news-item",
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:inline-block;padding:16px 24px 24px;width:100%;&:hover{background-color:rgba(0,0,0,0.03);}", dist.mq.untilMedium, "{padding:16px;}"),
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;justify-content:space-between;margin-bottom:8px;"),
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-right:16px;"),
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                    href: "".concat(props.financeNews.organization.path, "#news"),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                        className: "title",
                                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";font-size:14px;line-height:150%;color:", dist/* colors.black30 */.O9.black30, ";margin-bottom:8px;text-decoration:underline solid transparent;transition:text-decoration 0.2s ease 0s;&:hover{text-decoration:underline solid Currentcolor;transition:text-decoration 0.2s ease 0s;}", dist.mq.untilMedium, "{font-size:15px;}"),
                                        children: props.financeNews.title
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("> *:not(:last-child){margin-right:8px;}"),
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CategoryTag, {
                                            category: props.financeNews.category
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                            className: "date",
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:12px;line-height:100%;color:", dist/* colors.textLight */.O9.textLight, ";"),
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormattedDate/* FormattedDate */.J, {
                                                children: props.financeNews.postedDate
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                href: props.financeNews.organization.path,
                                passHref: true,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                    className: "item-image",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* CompanyLogo */.Dc, {
                                        src: props.financeNews.organization.logoPath || "/static/images/default/company.png",
                                        name: props.financeNews.organization.name,
                                        className: "company-logo",
                                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("&:hover{box-shadow:0px 0px 12px rgba(0,0,0,0.08);}")
                                    })
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                        href: props.financeNews.organization.path,
                        passHref: true,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                            className: "company-name",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.black10 */.O9.black10, ";font-size:14px;line-height:140%;text-decoration:underline solid transparent;transition:text-decoration 0.2s ease 0s;&:hover{text-decoration:underline solid Currentcolor;transition:text-decoration 0.2s ease 0s;}", dist.mq.untilMedium, "{line-height:150%;}"),
                            children: props.financeNews.organization.name
                        })
                    })
                })
            ]
        })
    });
};
var CategoryTag = function(param) {
    var category = param.category;
    var ref = (0,colors/* getCategoryTagColor */.O6)(category), color = ref.color, backgroundColor = ref.backgroundColor;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: "category",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:inline-flex;align-items:center;justify-content:center;height:18px;color:", color, ";background-color:", backgroundColor, ";border-radius:15px;padding:0 8px;"),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:12px;line-height:18px;font-weight:", dist/* font.weight.normal */.LZ.weight.normal, ";"),
            children: category
        })
    });
};

;// CONCATENATED MODULE: ./components/pages/top/LatestCompanies.tsx






var LatestCompanies = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TopSectionCard, {
        id: "latest-company-section",
        className: "latest-companies",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TopSectionCardTitle, {
                title: "新規登録",
                subTitle: "国内スタートアップ",
                showAllUrl: "/companies?sort=created&order=DESC&country=JPN"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("> *:not(:last-child){position:relative;}> *:not(:last-child)::after{content:'';position:absolute;height:1px;bottom:0px;left:16px;width:calc(100% - 32px);background-color:", dist/* colors.gray50 */.O9.gray50, ";}", dist.mq.untilMedium, "{> *:not(:last-child){margin-bottom:8px;}> *:not(:last-child)::after{display:none;}}"),
                children: props.companies.slice(0, 5).map(function(company, i) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LatestCompanyItem, {
                        company: company
                    }, i);
                })
            })
        ]
    });
};
var LatestCompanyItem = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background-color:", dist/* colors.white00 */.O9.white00, ";", dist.mq.untilMedium, "{border-radius:8px;box-shadow:0px 0px 4px rgba(0,0,0,0.08);}"),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
            href: props.company.path,
            passHref: true,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                className: "company-item",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:inline-block;color:", dist/* colors.black10 */.O9.black10, ";padding:16px 24px 24px;width:100%;&:hover{background-color:rgba(0,0,0,0.03);}", dist.mq.untilMedium, "{padding:16px;}"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;margin-bottom:8px;justify-content:space-between;"),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                className: "company-name",
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-right:16px;flex:1;", dist.mq.untilMedium, "{width:unset;}"),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";font-size:14px;line-height:140%;text-decoration:underline solid transparent;transition:text-decoration 0.2s ease 0s;&:hover{text-decoration:underline solid Currentcolor;transition:text-decoration 0.2s ease 0s;}", dist.mq.untilMedium, "{font-size:15px;}"),
                                    children: props.company.name
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* CompanyLogo */.Dc, {
                                src: props.company.imageUrl || "/static/images/default/company.png",
                                name: props.company.name,
                                className: "company-logo",
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("&:hover{box-shadow:0px 0px 12px rgba(0,0,0,0.08);}")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.black30 */.O9.black30, ";overflow:hidden;"),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LineClampText/* LineClampText */.R, {
                            className: "company-description",
                            lineNumber: 4,
                            height: 1.5,
                            size: "14px",
                            children: props.company.description
                        })
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./lib/npFeeds.ts
var REPORT_BANNER_POSITION = 8;
var isBannerPosition = function(feedsLength, index) {
    var feedsLengthAboveReportBanner = REPORT_BANNER_POSITION - 1;
    return feedsLength < feedsLengthAboveReportBanner && feedsLength === index + 1 || index + 1 === feedsLengthAboveReportBanner;
};
var toOddNumberFeeds = function(feeds) {
    if (feeds.length % 2 === 0) {
        return feeds.slice(0, feeds.length - 1);
    } else {
        return feeds;
    }
};
var LAUNCH_PITCH_BANNER_POSITION = 14;
var isLaunchPitchBannerPosition = function(feedsLength, index) {
    var feedsLengthAboveLaunchPitchBanner = LAUNCH_PITCH_BANNER_POSITION - 1;
    return feedsLength < feedsLengthAboveLaunchPitchBanner && feedsLength === index + 1 || index + 1 === feedsLengthAboveLaunchPitchBanner;
};

// EXTERNAL MODULE: ./lib/url.ts
var url = __webpack_require__(48261);
// EXTERNAL MODULE: ./components/common/npStartup/NPFeedPublisherAndPublishedDate.tsx
var NPFeedPublisherAndPublishedDate = __webpack_require__(39347);
// EXTERNAL MODULE: ./components/common/npStartup/PickersIcons.tsx
var PickersIcons = __webpack_require__(3278);
;// CONCATENATED MODULE: ./components/pages/top/NewsPicksStartupMoreLink.tsx







var NewsPicksStartupMoreLink = function() {
    var href = (0,url/* addNewsPicksTrackingParam */.al)(url/* newsPicksStartupUrl */.aI);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            className: "np-startup-link",
            id: "toppage-readmore-link",
            target: "_blank",
            rel: "noopener noreferrer",
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:block;width:100%;font-size:14px;font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";line-height:100%;text-align:center;align-items:center;border:1px solid ", dist/* colors.black10 */.O9.black10, ";box-sizing:border-box;border-radius:2px;padding:16px 0;letter-spacing:0.25px;transition:all 0.2s ease;color:", dist/* colors.black10 */.O9.black10, ";&:hover{background-color:", dist/* colors.black20 */.O9.black20, ";color:", dist/* colors.white00 */.O9.white00, ";transition:all 0.2s ease;}", dist.mq.untilMedium, "{padding:13px 0;}"),
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                children: "もっと見る"
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/pages/top/MainSection.tsx













var MainSection = function(props) {
    var showedFeeds = props.feeds.slice(0, 15);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(dist.mq.untilMedium, "{padding:0 12px;}"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "np-feed",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-flow:row wrap;justify-content:flex-start;gap:32px;", dist.mq.untilMedium, "{justify-content:center;gap:8px;}"),
                children: showedFeeds.map(function(feed, i) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsPicksFeed, {
                                index: i + 1,
                                feed: feed,
                                large: i === 0
                            }, i),
                            isBannerPosition(showedFeeds.length, i) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReportBanner, {}, "report-banner"),
                            isLaunchPitchBannerPosition(showedFeeds.length, i) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LaunchPitchBanner, {}, "launchpitch-banner")
                        ]
                    });
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-block:32px;", dist.mq.untilMedium, "{margin-block-end:0;}"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsPicksStartupMoreLink, {})
            })
        ]
    });
};
var ReportBanner = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: "https://jp.ub-speeda.com/document/260730wp/",
        passHref: true,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
            className: "report-banner",
            target: "_blank",
            rel: "noopener noreferrer",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("overflow:hidden;height:240px;border-radius:8px;position:relative;&:after{position:absolute;display:block;content:'';top:0;left:0;height:100%;width:100%;background-color:transparent;opacity:0.08;transition:background-color 0.2s ease;}&:hover:after{background-color:#000000;transition:background-color 0.2s ease;}", dist.mq.untilMedium, "{display:none;}"),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:100%;"),
                        src: "/static/images/top/bn_startupfinance2026_first_half_pc.png"
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:100%;border-radius:8px;display:none;", dist.mq.untilMedium, "{display:inline-block;vertical-align:top;}"),
                    src: "/static/images/top/bn_startupfinance2026_first_half_sp.png"
                })
            ]
        })
    });
};
// Note: バナー更新時この値を変更する
var launchPitch = {
    url: "https://newspicks.com/user/6312",
    imageUrl: "/static/images/top/launchpitch_banner.png"
};
var LaunchPitchBanner = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: launchPitch.url,
        passHref: true,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            className: "report-banner",
            target: "_blank",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("overflow:hidden;border-radius:8px;position:relative;&:after{position:absolute;display:block;content:'';top:0;left:0;height:100%;width:100%;background-color:transparent;opacity:0.08;transition:background-color 0.2s ease;}&:hover:after{background-color:#000000;transition:background-color 0.2s ease;}"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:100%;"),
                    src: launchPitch.imageUrl
                })
            })
        })
    });
};
var NewsPicksFeed = function(param) {
    var feed = param.feed, index = param.index, _large = param.large, large = _large === void 0 ? false : _large;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: large ? "np-feed-item large" : "np-feed-item",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:", large ? "736px" : "352px", ";box-shadow:0px 4px 16px rgba(0,0,0,0.04);&:hover{box-shadow:0px 4px 24px rgb(0 0 0 / 12%);}", dist.mq.untilMedium, "{width:100%;box-shadow:0px 0px 4px rgba(0,0,0,0.08);}background:", dist/* colors.white00 */.O9.white00, ";border-radius:8px;overflow:hidden;transition:all 0.4s ease 0s;"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsPicksFeedDetail, {
                feed: feed,
                index: index,
                large: large
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("hr", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:16px 16px;border:none;height:1px;background-color:", dist/* colors.gray50 */.O9.gray50, ";")
            }),
            feed.topPick && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsPicksTopPick, {
                index: index,
                topPick: feed.topPick,
                articleUrl: feed.articleUrl,
                large: large,
                newsId: feed.newsId
            })
        ]
    });
};
var NewsPicksFeedDetail = function(props) {
    var pickersForDisplay = props.feed.pickers.slice(0, 5);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsPicksFeedsBannerAndTitle, {
                feed: props.feed,
                index: props.index,
                large: props.large
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:0px 16px;"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NPFeedPublisherAndPublishedDate/* NPFeedPublisherAndPublishedDate */.c, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-bottom:12px;")
                    }, props.feed), {
                        fontSize: "12px",
                        lineHeight: 1.16666
                    })),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;"),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-right:8px;height:28px;"),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PickersIcons/* PickersIcons */.q, {
                                    pickers: pickersForDisplay,
                                    className: "np-feed-pickers"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:fit-content;color:", dist/* colors.black30 */.O9.black30, ";line-height:100%;"),
                                className: "np-feed-pick-count",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-right:2px;font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";font-size:16px;"),
                                        children: props.feed.pickCount
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:14px;"),
                                        children: "Picks"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var NewsPicksFeedsBannerAndTitle = function(props) {
    var bannerImageUrl = props.feed.image || "/static/images/top/np-feed-blank-banner.jpg";
    var articleUrl = (0,url/* addNewsPicksTrackingParam */.al)(props.feed.articleUrl, props.feed.newsId);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;", dist.mq.untilMedium, "{flex-direction:", props.large ? "column" : "row-reverse", ";justify-content:space-between;margin:", props.large ? "0 0 8px" : "16px 0 8px", ";}"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(dist.mq.untilMedium, "{display:flex;align-items:center;}"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    className: "np-feed-banner",
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:100%;overflow:hidden;", dist.mq.untilMedium, "{width:", props.large ? "100%" : "112px", ";display:flex;align-items:center;margin-right:", props.large ? "0" : "16px", ";margin-bottom:", props.large ? "16px" : "0", ";border-radius:2px;}"),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                        href: articleUrl,
                        passHref: true,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                            id: "toppage-banner-".concat(props.index),
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:relative;justify-content:center;&:after{position:absolute;display:block;content:'';top:0;left:0;height:100%;width:100%;background-color:transparent;opacity:0.08;transition:background-color 0.2s ease;}&:hover:after{background-color:#000000;transition:background-color 0.2s ease;}"),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                                    src: (0,url/* resizeBannerImageUrl */.QQ)(bannerImageUrl, props.large ? 736 : 600, props.large ? 385 : 315),
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:block;width:100%;object-fit:contain;aspect-ratio:1.91 / 1;")
                                })
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:16px 16px 8px;font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";font-size:18px;line-height:150%;min-height:", props.large ? "unset" : "54px", ";overflow:hidden;", dist.mq.untilMedium, "{width:calc(100% - 32px);margin:0 8px 0 16px;min-height:", props.large ? "unset" : "46px", ";height:auto;display:flex;align-items:center;}"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                    href: articleUrl,
                    passHref: true,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                        id: "toppage-title-".concat(props.index),
                        className: "np-feed-title",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.black10 */.O9.black10, ";text-decoration:underline solid transparent;transition:text-decoration 0.2s ease 0s;&:hover{text-decoration:underline solid Currentcolor;transition:text-decoration 0.2s ease 0s;}"),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LineClampText/* LineClampText */.R, {
                            className: "np-feed-title-text",
                            lineNumber: {
                                desktop: 2,
                                mobile: 2
                            },
                            size: props.large ? "24px" : "18px",
                            height: 1.5,
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(dist.mq.untilMedium, "{font-size:", props.large ? "18px" : "15px", ";}"),
                            children: props.feed.title
                        })
                    })
                })
            })
        ]
    });
};
var NewsPicksTopPick = function(props) {
    var articleUrl = (0,url/* addNewsPicksTrackingParam */.al)(props.articleUrl, props.newsId);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: articleUrl,
        passHref: true,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
            id: "toppage-toppick-".concat(props.index),
            target: "_blank",
            className: "np-feed-top-pick",
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.black10 */.O9.black10, ";margin:0px 16px 24px;text-decoration:none;transition:all 0.2s ease;display:block;&:hover{transition:all 0.2s ease;opacity:0.8;}", dist.mq.untilMedium, "{margin:0px 16px 16px;}"),
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;margin-bottom:8px;"),
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                            alt: "picker icon",
                            className: "np-feed-picker-icon",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("height:32px;width:32px;border-radius:50%;margin-right:", props.large ? "10px" : "8px", ";display:block;"),
                            src: props.topPick.picker.image ? props.topPick.picker.image : "/static/images/top/np-picker-blank-avatar.png"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("flex-grow:1;min-width:0;"),
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-bottom:", props.topPick.picker.title ? "4px" : "3px", ";"),
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                            className: "np-feed-picker-name",
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";font-size:14px;line-height:15px;margin-right:4px;vertical-align:middle;"),
                                            children: props.topPick.picker.name
                                        }),
                                        props.topPick.picker.isProPicker && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProPickerBadge, {
                                            className: "np-feed-pro-picker-badge"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    className: "np-feed-picker-title",
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("text-overflow:ellipsis;overflow:hidden;white-space:nowrap;font-size:12px;line-height:100%;color:", dist/* colors.textLight */.O9.textLight, ";"),
                                    children: props.topPick.picker.title
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-left:40px;"),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.black30 */.O9.black30, ";overflow:hidden;"),
                        children: props.topPick.comment ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LineClampText/* LineClampText */.R, {
                            className: "np-feed-comment",
                            lineNumber: 3,
                            size: "13px",
                            height: 1.5,
                            children: props.topPick.comment
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                className: "np-feed-comment",
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:13px;line-height:1.4;"),
                                children: "まだコメントがありません。"
                            })
                        })
                    })
                })
            ]
        })
    });
};
var ProPickerBadge = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
        className: className,
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:inline-flex;align-items:center;text-align:center;width:min-content;height:min-content;vertical-align:middle;font-style:italic;font-size:10px;line-height:100%;border-radius:8px;padding:2px 6px 1px 5px;background-color:", dist/* colors.black10 */.O9.black10, ";color:", dist/* colors.white00 */.O9.white00, ";"),
        children: "PRO"
    });
};

;// CONCATENATED MODULE: ./components/pages/top/MobileGradationBackground.tsx



var MobileGradationBackground = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(dist.mq.untilMedium, "{background:linear-gradient(\n            180deg,", dist/* colors.gray40 */.O9.gray40, " 50%,", dist/* colors.white10 */.O9.white10, " 100%\n          );}"),
        className: props.className,
        children: props.children
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./hooks/useIsTop.ts


var useIsTop = function(initialState) {
    var ref = (0,react.useState)(initialState), isTop = ref[0], setIsTop = ref[1];
    var checkIfTop = function() {
        // 16px は違和感がない範囲を見て決めた
        if (window.scrollY >= 16) {
            setIsTop(false);
        } else {
            setIsTop(true);
        }
    };
    (0,react.useEffect)(checkIfTop, []);
    (0,react.useEffect)(function() {
        document.addEventListener("scroll", (0,lodash.throttle)(checkIfTop, 200));
        return function() {
            return document.removeEventListener("scroll", (0,lodash.throttle)(checkIfTop, 200));
        };
    }, []);
    return isTop;
};

// EXTERNAL MODULE: ./lib/user.ts
var lib_user = __webpack_require__(73650);
// EXTERNAL MODULE: ./contexts/AuthContext.ts
var AuthContext = __webpack_require__(18584);
;// CONCATENATED MODULE: ./components/pages/top/MobileTopNavBar.tsx









var MobileTopNavBar = function() {
    var isTop = useIsTop(true);
    var ref = (0,react.useRef)(null);
    var user = (0,AuthContext/* useUser */.a)();
    var check = function() {
        if (ref.current === null) return;
        var activeButton = ref.current.querySelector(".top-nav-bar-button.active");
        if (activeButton === null) return;
        ref.current.scroll({
            left: activeButton.offsetLeft - 32,
            behavior: "smooth"
        });
    };
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", (0,lodash.throttle)(check, 200));
        return function() {
            window.removeEventListener("scroll", (0,lodash.throttle)(check, 200));
        };
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: "top-nav-bar",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:none;", dist.mq.untilMedium, "{position:sticky;display:block;top:54px;z-index:19;overflow-x:auto;transition:background-color 0.2s ease;background-color:", isTop ? "transparent" : dist/* colors.white00 */.O9.white00, ";box-shadow:", isTop ? "none" : "0px 0px 4px rgba(0, 0, 0, 0.08)", ";height:48px;width:100vw;padding:10px 0;white-space:nowrap;scrollbar-width:none;-ms-overflow-style:none;font-size:14px;line-height:1;&::-webkit-scrollbar{display:none;}}"),
        ref: ref,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("align-items:center;display:flex;height:100%;width:min-content;white-space:nowrap;padding:0 16px;> *:not(:last-child){margin-right:4px;}"),
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileTopNavBarButton, {
                    name: "記事",
                    id: "np-feed"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileTopNavBarButton, {
                    name: "資金調達・提携ニュース",
                    id: "finance-ma-section"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileTopNavBarButton, {
                    name: "スタートアップアクセスランキング",
                    id: "access-ranking-section"
                }),
                (0,lib_user/* isEnterpriseWithTrial */.xQ)(user) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileTopNavBarButton, {
                    name: "国内新規登録スタートアップ",
                    id: "latest-company-section"
                })
            ]
        })
    });
};
var MobileTopNavBarButton = function(props) {
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isActive = ref[0], setIsActive = ref[1];
    var navigationSectionHeight = 55 + 53;
    var onClick = function() {
        var targetElement = document.getElementById(props.id);
        if (targetElement === null) return;
        var positionTop = targetElement.offsetTop;
        window.scrollTo({
            top: positionTop - navigationSectionHeight,
            behavior: "smooth"
        });
    };
    var checkIfActive = function() {
        var targetElement = document.getElementById(props.id);
        if (targetElement === null) return;
        var topPosition = props.id === "np-feed" ? 0 : targetElement.offsetTop;
        var elementHeight = targetElement.clientHeight;
        var bottomPosition = props.id === "np-feed" ? targetElement.offsetTop + elementHeight : topPosition + elementHeight;
        var scrollY = window.scrollY + navigationSectionHeight + 8;
        if (topPosition <= scrollY && scrollY < bottomPosition) {
            setIsActive(true);
        } else {
            setIsActive(false);
        }
    };
    (0,react.useEffect)(checkIfActive, []);
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", (0,lodash.throttle)(checkIfActive, 200));
        return function() {
            window.removeEventListener("scroll", (0,lodash.throttle)(checkIfActive, 200));
        };
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: isActive ? "top-nav-bar-button active" : "top-nav-bar-button",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:9px 16px;width:fit-content;height:32px;color:", dist/* colors.black10 */.O9.black10, ";background-color:", dist/* colors.gray40 */.O9.gray40, ";border-radius:36px;word-break:keep-all;&.active{color:", dist/* colors.white00 */.O9.white00, ";background-color:", dist/* colors.black10 */.O9.black10, ";}"),
        onClick: onClick,
        children: props.name
    });
};

// EXTERNAL MODULE: ./hooks/useTimeout.ts
var useTimeout = __webpack_require__(28547);
;// CONCATENATED MODULE: ./components/pages/top/Notification.tsx







var TopDesktopNotification = function(props) {
    var isTimeout = (0,useTimeout/* useTimeout */.K)(2000);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: "new-top-notification",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;height:40px;width:100%;transition:all 1s cubic-bezier(0.67,0.01,1,1);background-color:", isTimeout ? dist/* colors.white00 */.O9.white00 : "#0071e3", ";color:", isTimeout ? dist/* colors.black30 */.O9.black30 : dist/* colors.white00 */.O9.white00, ";justify-content:center;", dist.mq.untilMedium, "{display:none;}"),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;justify-content:center;"),
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;height:20px;width:100px;transition:all 1.5s ease-in;background-color:", isTimeout ? dist/* colors.black10 */.O9.black10 : "#0051d6", ";align-items:center;justify-content:center;font-size:12px;line-height:1;color:", dist/* colors.white00 */.O9.white00, ";border-radius:2px;"),
                    children: props.category
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:0 24px;font-size:14px;line-height:21px;"),
                    children: props.text
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:14px;line-height:21px;"),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                        href: props.detailUrl,
                        passHref: true,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                            className: "notification-path",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", !isTimeout ? dist/* colors.white00 */.O9.white00 : dist/* colors.link */.O9.link, ";transition:color 1.5s ease-in;"),
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("transition:text-decoration 0.2s ease 0s;text-decoration:underline solid transparent;&:hover{text-decoration:underline solid Currentcolor;transition:text-decoration 0.2s ease 0s;}"),
                                    children: "詳しく見る"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:9px;font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";margin-left:5px;position:relative;top:-1px;"),
                                    name: "arrow4-right"
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
var TopMobileNotification = function(props) {
    var isTimeout = (0,useTimeout/* useTimeout */.K)(2000);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: props.detailUrl,
        passHref: true,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
            className: "notification-path",
            target: "_blank",
            rel: "noopener noreferrer",
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:none;", dist.mq.untilMedium, "{display:flex;}padding:8px 16px;width:100%;min-height:48px;justify-content:space-between;transition:all 1s cubic-bezier(0.67,0.01,1,1);background-color:", isTimeout ? dist/* colors.white00 */.O9.white00 : "#0071e3", ";color:", isTimeout ? dist/* colors.black30 */.O9.black30 : dist/* colors.white00 */.O9.white00, ";font-size:14px;line-height:150%;align-items:center;"),
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                    className: "new-top-mobile-notification",
                    children: props.text
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:9px;font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";margin-left:5px;position:relative;top:-1px;"),
                    name: "arrow4-right"
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./pages/index.tsx
















var GlobalPage = function(props) {
    var domesticFinanceNewsList = props.domesticFinanceNewsList, dailyRankingCompanies = props.dailyRankingCompanies, latestCompanies = props.latestCompanies, notice = props.notice;
    var user = (0,AuthContext/* useUser */.a)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Template/* Template */.Y, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Head/* DefaultHead */.UJ, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background-color:", dist/* colors.gray40 */.O9.gray40, ";min-height:100vh;margin:auto;"),
                children: [
                    notice && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TopDesktopNotification, {
                        category: "お知らせ",
                        text: notice.title,
                        detailUrl: (0,url/* noticePath */.$t)(notice.slug || notice.id)
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("max-width:1136px;margin:auto;"),
                        children: [
                            notice && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TopMobileNotification, {
                                text: notice.title,
                                detailUrl: (0,url/* noticePath */.$t)(notice.slug || notice.id)
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileTopNavBar, {}),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;> *{flex-grow:0;flex-shrink:0;}> *:nth-of-type(1){width:736px;margin-right:48px;}> *:nth-of-type(2){width:352px;}", dist.mq.untilMedium, "{flex-direction:column;> *:nth-of-type(n){width:100%;margin-right:0;}}"),
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                        id: "np-feed",
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {}),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileGradationBackground, {
                                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(dist.mq.untilMedium, "{margin-bottom:24px;padding-bottom:24px;}"),
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MainSection, {
                                                    feeds: props.npFeeds
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-top:70px;", dist.mq.untilMedium, "{padding-top:0px;}"),
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;> *{margin-bottom:32px;}", dist.mq.untilMedium, "{> *{margin-bottom:24px;}}"),
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileGradationBackground, {
                                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(dist.mq.untilMedium, "{padding:0 12px 24px;}"),
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DomesticFinanceNewsSection, {
                                                        financeNews: domesticFinanceNewsList
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileGradationBackground, {
                                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(dist.mq.untilMedium, "{padding:0 12px 24px;}"),
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyAccessRanking, {
                                                        companies: dailyRankingCompanies
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileGradationBackground, {
                                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(dist.mq.untilMedium, "{padding:0 12px 24px;margin-bottom:0;}"),
                                                    children: (0,lib_user/* isEnterpriseWithTrial */.xQ)(user) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LatestCompanies, {
                                                        companies: latestCompanies
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var Title = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;padding:24px 0px 10px 0px;", dist.mq.untilMedium, "{padding:8px 16px;flex-direction:column;}"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-style:normal;font-size:24px;line-height:36px;margin-right:12px;", dist.mq.untilMedium, "{font-size:20px;line-height:1.5;font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";}"),
                children: "スタートアップヘッドライン"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: "powered-by-newspicks",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-style:italic;font-size:12px;line-height:100%;color:", dist/* colors.textLight */.O9.textLight, ";display:flex;align-items:center;", dist.mq.untilMedium, "{line-height:1.5;}"),
                children: [
                    "Powered by\xa0",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                        href: url/* newsPicksTopUrl */.bM,
                        passHref: true,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.textLight */.O9.textLight, ";&:hover{color:", dist/* colors.link */.O9.link, ";}"),
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "NewsPicks"
                        })
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var pages = (GlobalPage);


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,8687,519,774,3431,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);